import { Component, Input, ChangeDetectorRef } from '@angular/core';
import { BreadCumb } from '../models/breadcumb';
import { MediaMatcher } from '@angular/cdk/layout';
import { Route, Router } from '@angular/router';

@Component({
  selector: 'inova-breadcumbs',
  templateUrl: './breadcumb.component.html',
  styleUrls: ['./breadcumb.component.scss']
})
export class BreadcumbComponent {

  @Input()
  data:BreadCumb[]=[];

  @Input()
  itemMaxLength=20;

  @Input()
  responsive=false;

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(changeDetectorRef: ChangeDetectorRef,
    private route:Router,
    media: MediaMatcher,) {
    this.mobileQuery = media.matchMedia('(max-width: 750px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    }


  getText(text:string){
    if(text && text.length>0){
      if(this.isTextOverLimit(text)){
        return text.substring(0,this.itemMaxLength)+"...";
      }
    }
    return text;
  }

  isTextOverLimit(text:string){
    return text.length>this.itemMaxLength;
  }

  getTooltip(text:string){
    if(this.isTextOverLimit(text)){
      return text;
    }
    return "";
  }

  redirectTo(item:BreadCumb){
    if(item.extras){
      this.route.navigate(item.route,item.extras);
      return;
    }
    else{
      this.route.navigate(item.route);
    }
  }

}
